import styled from "@emotion/styled"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import Button from "@mui/material/Button"
import { darken } from "@mui/system"

export const CustomButton = styled(Button)`
  color: ${({ theme }) => theme.palette.primary.light};
  background-color: ${({ theme, color }) =>
    theme.palette[color]
      ? theme.palette[color].main
      : theme.palette.secondary.main};
  padding: 13px 24px;
  border: 1px solid transparent;
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  font-weight: 550 !important;
  border-radius: 8px;
  text-transform: capitalize;

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: 15px;
    font-size: 1rem;
  }

  &.light {
    background-color: white;
    color: ${({ theme }) => theme.palette.tertiary.main};

    &:hover {
      background-color: rgba(255, 255, 255, 0.9);
    }
  }

  &.linearGradient {
    background: linear-gradient(90deg, #00a179 0%, #008d8d 100%);

    &:hover {
      background: linear-gradient(90deg, #008d8d 0%, #00a179 100%);
    }
  }

  &.darkBorder {
    color: ${({ theme }) => theme.palette.primary.light};
    border: 1px solid ${({ theme }) => theme.palette.primary.light};
    background-color: transparent;
    svg path {
      fill: ${({ theme }) => theme.palette.primary.light};
    }
    &:hover {
      background-color: ${({ theme }) => theme.palette.secondary.main};
    }
  }

  &.lightBorder {
    color: ${({ theme }) => theme.palette.secondary.main};
    border: 0.7px solid ${({ theme }) => theme.palette.tertiary.light};
    background-color: transparent;

    &:hover {
      background: rgba(0, 161, 121, 0.1) !important;
    }
  }

  &:not(.light):not(.darkBorder):hover {
    background-color: ${({ theme, color }) =>
      darken(
        theme.palette[color]
          ? theme.palette[color].main
          : theme.palette.secondary.main,
        0.1,
      )};
    /* border: 1px solid ${({ theme }) =>
      darken(theme.palette.primary.main, 0.1)}; */
  }

  &.Mui-disabled {
    color: rgba(0, 0, 0, 0.26);
    background: lightgray;
    border-color: lightgray;
    cursor: not-allowed;
  }
`

export const CustomButtonLink = styled(AniLink)`
  color: white;
  background-color: ${({ theme, color }) =>
    theme.palette[color]
      ? theme.palette[color].main
      : theme.palette.primary.main};
  padding: 0.5em 1.5em;
  text-transform: unset;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  font-weight: 600;
  border-radius: 5px;
  text-decoration: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  min-height: 40px;

  &.light {
    background-color: white;
    color: ${({ theme }) => theme.palette.primary.main};
  }

  &.darkBorder {
    color: ${({ theme }) => theme.palette.primary.main};
    border: 1px ${({ theme }) => theme.palette.primary.main} solid;
    background-color: transparent;

    &:hover {
      background-color: ${({ theme }) => theme.palette.primary.main};
      color: white;
    }
  }

  &.lightBorder {
    color: white;
    border: 1px white solid;
    background-color: transparent;
  }

  &:not(.light):not(.darkBorder):hover {
    background-color: ${({ theme, color }) =>
      darken(
        theme.palette[color]
          ? theme.palette[color].main
          : theme.palette.primary.main,
        0.1,
      )};
    //border: 1px solid ${({ theme }) =>
      darken(theme.palette.primary.main, 0.1)};
  }

  &.Mui-disabled {
    color: rgba(0, 0, 0, 0.26);
    background: lightgray;
    border-color: lightgray;
    cursor: not-allowed;
  }
`
